var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleGmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:google-gmail",
    clipPath: "url(#clip0_1769_8820)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.69591 21.7758V11.0136L3.22101 7.9601L0.10498 6.26562V19.8766C0.10498 20.9274 0.991406 21.7758 2.0823 21.7758H6.69591Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.514 21.7757H27.1276C28.2218 21.7757 29.105 20.9242 29.105 19.8765V6.26562L25.5756 8.20644L22.514 11.0135V21.7757Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.69586 11.013L6.22302 6.80791L6.69586 2.7832L14.6049 8.48084L22.514 2.7832L23.0429 6.59062L22.514 11.013L14.6049 16.7107L6.69586 11.013Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.514 2.78345V11.0133L29.105 6.26532V3.73302C29.105 1.3844 26.3137 0.0455098 24.3596 1.45403L22.514 2.78345Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.10498 6.26537L3.13627 8.44915L6.69591 11.0133V2.7835L4.85033 1.45408C2.89283 0.045451 0.10498 1.38445 0.10498 3.73296V6.26537Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1769_8820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 21,
    fill: "white",
    transform: "translate(0.10498 0.878906)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGmailIcon);
export default __webpack_public_path__ + "static/media/google-gmail-icon.7ba7ecdf9289ccc9de51c2fdbe287dbd.svg";
export { ForwardRef as ReactComponent };